import { styled } from '@mui/material/styles';

import Card from '@mui/material/Card';

const StyledCard = styled(Card)(({ theme }) => ({
    backgroundColor: theme.palette.secondary.main,
}));

export default StyledCard;
